// src/components/WebTabNavigation.js - Fixed with proper logout
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useAuth } from '../context/AuthContext';

// Web-compatible icon component
const WebIcon = ({ name, size = 24, color = '#666' }) => {
  const iconMap = {
    'clipboard-list': '📋',
    'truck-delivery': '🚚',
    'logout': '🚪',
    'gavel': '⚖️',
    'hourglass': '⏳',
  };
  
  return (
    <Text style={{ fontSize: size, color, textAlign: 'center' }}>
      {iconMap[name] || '◯'}
    </Text>
  );
};

function WebTabNavigation({ activeTab, onTabChange, user }) {
  const { logout, isLoggingOut } = useAuth(); // Get logout function and state from AuthContext

  const tabs = [
    {
      key: 'tender',
      title: 'מכרזים',
      icon: 'gavel'
    },
    {
      key: 'direct',
      title: 'הזמנות ישירות',
      icon: 'truck-delivery'
    },
     {
      key: 'history',
      title: 'היסטוריה',
      icon: 'truck-delivery'
    }
  ];

  const handleLogout = async () => {
    // Prevent multiple logout attempts
    if (isLoggingOut) {
      console.log('🔄 Logout already in progress...');
      return;
    }

    const confirmLogout = window.confirm('האם אתה בטוח שברצונך להתנתק?');
    
    if (confirmLogout) {
      try {
        console.log('🚪 Starting logout from WebTabNavigation...');
        
        // Use the proper logout function from AuthContext
        await logout();
        
        console.log('✅ Logout completed successfully');
        
        // Clear any additional browser storage and reset URL
        localStorage.clear();
        sessionStorage.clear();
        window.history.replaceState({}, '', '/');
        
      } catch (error) {
        console.error('❌ Logout failed:', error);
        
        // Show error and force reload as fallback
        alert('שגיאה בהתנתקות. הדף יטען מחדש.');
        window.location.reload();
      }
    }
  };

  const handleTabChange = (tabKey) => {
    // Don't allow tab changes during logout
    if (isLoggingOut) {
      return;
    }
    onTabChange(tabKey);
  };

  return (
    <View style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          <Text style={styles.headerTitle}>MyPizza - OrderHR</Text>
          {user && !isLoggingOut && (
            <Text style={styles.userInfo}>
              {user.franchiseeName || user.branchName || 'משתמש'}
            </Text>
          )}
          {isLoggingOut && (
            <Text style={styles.userInfo}>מתנתק...</Text>
          )}
        </View>
        
        <TouchableOpacity 
          style={[
            styles.logoutButton,
            isLoggingOut && styles.logoutButtonDisabled
          ]} 
          onPress={handleLogout}
          disabled={isLoggingOut}
        >
          <WebIcon 
            name={isLoggingOut ? "hourglass" : "logout"} 
            size={20} 
            color="#fff" 
          />
          <Text style={styles.logoutText}>
            {isLoggingOut ? 'מתנתק...' : 'יציאה'}
          </Text>
        </TouchableOpacity>
      </View>
      
      {/* Tab Bar */}
      <View style={styles.tabContainer}>
        {tabs.map((tab) => (
          <TouchableOpacity
            key={tab.key}
            style={[
              styles.tab,
              activeTab === tab.key && styles.activeTab,
              isLoggingOut && styles.tabDisabled
            ]}
            onPress={() => handleTabChange(tab.key)}
            disabled={isLoggingOut}
          >
            <WebIcon 
              name={tab.icon} 
              size={20} 
              color={
                isLoggingOut 
                  ? '#ccc' 
                  : activeTab === tab.key 
                    ? '#2196F3' 
                    : '#666'
              } 
            />
            <Text style={[
              styles.tabText,
              activeTab === tab.key && styles.activeTabText,
              isLoggingOut && styles.tabTextDisabled
            ]}>
              {tab.title}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  header: {
    backgroundColor: '#2196F3',
    paddingVertical: 15,
    paddingHorizontal: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerLeft: {
    flex: 1,
  },
  headerTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  userInfo: {
    color: '#e3f2fd',
    fontSize: 12,
    marginTop: 2,
  },
  logoutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: 5,
  },
  logoutButtonDisabled: {
    opacity: 0.6,
  },
  logoutText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
    marginLeft: 8,
  },
  tabContainer: {
    flexDirection: 'row',
    backgroundColor: '#fff',
  },
  tab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 15,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
  },
  activeTab: {
    borderBottomColor: '#2196F3',
  },
  tabDisabled: {
    opacity: 0.6,
  },
  tabText: {
    marginLeft: 8,
    fontSize: 14,
    color: '#666',
  },
  activeTabText: {
    color: '#2196F3',
    fontWeight: 'bold',
  },
  tabTextDisabled: {
    color: '#ccc',
  },
});

export default WebTabNavigation;